import { render, staticRenderFns } from "./authloginPage.vue?vue&type=template&id=c20023de&scoped=true&"
import script from "./authloginPage.vue?vue&type=script&lang=js&"
export * from "./authloginPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c20023de",
  null
  
)

export default component.exports